module.exports = __webpack_public_path__ + "static/media/laddu_page05.423493ec.png";